/**
 * Generated by orval v8.11.0 🍺
 * Do not edit manually.
 * Core API
 * Core API Documentation
 * OpenAPI spec version: 1.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  BulkSetTemporaryPinsDto,
  CreateUserDto,
  GetUserLoginAttemptsParams,
  GetUserLoginAttemptsResponseDto,
  ListUsersQueryControllerListParams,
  ListUsersResponseDto,
  ManagerSetUserPinDto,
  ResetUserPasswordDto,
  UpdateUserDto,
  UserResponseDto,
} from "../model";

import { axiosClient } from "../../lib/api";

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

/**
 * @summary Get current user
 */
export const getSelfQueryControllerSelf = (signal?: AbortSignal) => {
  return axiosClient<UserResponseDto>({
    url: `/v1/users/self`,
    method: "GET",
    signal,
  });
};

export const getGetSelfQueryControllerSelfQueryKey = () => {
  return [`/v1/users/self`] as const;
};

export const getGetSelfQueryControllerSelfQueryOptions = <
  TData = Awaited<ReturnType<typeof getSelfQueryControllerSelf>>,
  TError = void,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getSelfQueryControllerSelf>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetSelfQueryControllerSelfQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getSelfQueryControllerSelf>>
  > = ({ signal }) => getSelfQueryControllerSelf(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSelfQueryControllerSelf>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetSelfQueryControllerSelfQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSelfQueryControllerSelf>>
>;
export type GetSelfQueryControllerSelfQueryError = void;

export function useGetSelfQueryControllerSelf<
  TData = Awaited<ReturnType<typeof getSelfQueryControllerSelf>>,
  TError = void,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSelfQueryControllerSelf>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSelfQueryControllerSelf>>,
          TError,
          Awaited<ReturnType<typeof getSelfQueryControllerSelf>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetSelfQueryControllerSelf<
  TData = Awaited<ReturnType<typeof getSelfQueryControllerSelf>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSelfQueryControllerSelf>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSelfQueryControllerSelf>>,
          TError,
          Awaited<ReturnType<typeof getSelfQueryControllerSelf>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetSelfQueryControllerSelf<
  TData = Awaited<ReturnType<typeof getSelfQueryControllerSelf>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSelfQueryControllerSelf>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get current user
 */

export function useGetSelfQueryControllerSelf<
  TData = Awaited<ReturnType<typeof getSelfQueryControllerSelf>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSelfQueryControllerSelf>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetSelfQueryControllerSelfQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Yourself, any user as a platform admin, or a member of a nursery you manage or of an organisation you actively administer.
 * @summary Get a single user
 */
export const getUser = (id: string, signal?: AbortSignal) => {
  return axiosClient<UserResponseDto>({
    url: `/v1/users/${id}`,
    method: "GET",
    signal,
  });
};

export const getGetUserQueryKey = (id: string) => {
  return [`/v1/users/${id}`] as const;
};

export const getGetUserQueryOptions = <
  TData = Awaited<ReturnType<typeof getUser>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getUser>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetUserQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getUser>>> = ({
    signal,
  }) => getUser(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: id !== null && id !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getUser>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type GetUserQueryResult = NonNullable<
  Awaited<ReturnType<typeof getUser>>
>;
export type GetUserQueryError = void;

export function useGetUser<
  TData = Awaited<ReturnType<typeof getUser>>,
  TError = void,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getUser>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUser>>,
          TError,
          Awaited<ReturnType<typeof getUser>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUser<
  TData = Awaited<ReturnType<typeof getUser>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getUser>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUser>>,
          TError,
          Awaited<ReturnType<typeof getUser>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUser<
  TData = Awaited<ReturnType<typeof getUser>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getUser>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get a single user
 */

export function useGetUser<
  TData = Awaited<ReturnType<typeof getUser>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getUser>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetUserQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Users may update themselves. Platform admins may update anyone; managers and org admins only users they manage. Only a platform admin may update a platform admin. To reset a password or change the active status, use the reset-password, activate and deactivate endpoints.
 * @summary Update a user in an organisation
 */
export const updateUserCommandControllerUpdate = (
  id: string,
  updateUserDto: UpdateUserDto,
  signal?: AbortSignal,
) => {
  return axiosClient<UserResponseDto>({
    url: `/v1/users/${id}`,
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    data: updateUserDto,
    signal,
  });
};

export const getUpdateUserCommandControllerUpdateMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateUserCommandControllerUpdate>>,
    TError,
    { id: string; data: UpdateUserDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateUserCommandControllerUpdate>>,
  TError,
  { id: string; data: UpdateUserDto },
  TContext
> => {
  const mutationKey = ["updateUserCommandControllerUpdate"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateUserCommandControllerUpdate>>,
    { id: string; data: UpdateUserDto }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateUserCommandControllerUpdate(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateUserCommandControllerUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateUserCommandControllerUpdate>>
>;
export type UpdateUserCommandControllerUpdateMutationBody = UpdateUserDto;
export type UpdateUserCommandControllerUpdateMutationError = void;

/**
 * @summary Update a user in an organisation
 */
export const useUpdateUserCommandControllerUpdate = <
  TError = void,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateUserCommandControllerUpdate>>,
      TError,
      { id: string; data: UpdateUserDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateUserCommandControllerUpdate>>,
  TError,
  { id: string; data: UpdateUserDto },
  TContext
> => {
  return useMutation(
    getUpdateUserCommandControllerUpdateMutationOptions(options),
    queryClient,
  );
};
/**
 * Soft-deletes the user and removes their login at every nursery. Platform admins only; nobody may delete themselves. Managers and org admins deactivate instead.
 * @summary Delete a user
 */
export const deleteUser = (id: string, signal?: AbortSignal) => {
  return axiosClient<void>({
    url: `/v1/users/${id}`,
    method: "DELETE",
    signal,
  });
};

export const getDeleteUserMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteUser>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteUser>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["deleteUser"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteUser>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return deleteUser(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteUserMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteUser>>
>;

export type DeleteUserMutationError = void;

/**
 * @summary Delete a user
 */
export const useDeleteUser = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteUser>>,
      TError,
      { id: string },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteUser>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getDeleteUserMutationOptions(options), queryClient);
};
/**
 * Platform admins only. Returns a paginated list of users across every organisation. Supports filtering by nursery access, nursery, role, and search.
 * @summary List users
 */
export const listUsersQueryControllerList = (
  params?: ListUsersQueryControllerListParams,
  signal?: AbortSignal,
) => {
  return axiosClient<ListUsersResponseDto>({
    url: `/v1/users`,
    method: "GET",
    params,
    signal,
  });
};

export const getListUsersQueryControllerListQueryKey = (
  params?: ListUsersQueryControllerListParams,
) => {
  return [`/v1/users`, ...(params ? [params] : [])] as const;
};

export const getListUsersQueryControllerListQueryOptions = <
  TData = Awaited<ReturnType<typeof listUsersQueryControllerList>>,
  TError = void,
>(
  params?: ListUsersQueryControllerListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listUsersQueryControllerList>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListUsersQueryControllerListQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listUsersQueryControllerList>>
  > = ({ signal }) => listUsersQueryControllerList(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listUsersQueryControllerList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListUsersQueryControllerListQueryResult = NonNullable<
  Awaited<ReturnType<typeof listUsersQueryControllerList>>
>;
export type ListUsersQueryControllerListQueryError = void;

export function useListUsersQueryControllerList<
  TData = Awaited<ReturnType<typeof listUsersQueryControllerList>>,
  TError = void,
>(
  params: undefined | ListUsersQueryControllerListParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listUsersQueryControllerList>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listUsersQueryControllerList>>,
          TError,
          Awaited<ReturnType<typeof listUsersQueryControllerList>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListUsersQueryControllerList<
  TData = Awaited<ReturnType<typeof listUsersQueryControllerList>>,
  TError = void,
>(
  params?: ListUsersQueryControllerListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listUsersQueryControllerList>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listUsersQueryControllerList>>,
          TError,
          Awaited<ReturnType<typeof listUsersQueryControllerList>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListUsersQueryControllerList<
  TData = Awaited<ReturnType<typeof listUsersQueryControllerList>>,
  TError = void,
>(
  params?: ListUsersQueryControllerListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listUsersQueryControllerList>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List users
 */

export function useListUsersQueryControllerList<
  TData = Awaited<ReturnType<typeof listUsersQueryControllerList>>,
  TError = void,
>(
  params?: ListUsersQueryControllerListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listUsersQueryControllerList>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getListUsersQueryControllerListQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Returns the audit trail of PIN logins (success/failure/locked/unlocked) and manager account actions (PIN reset, password reset, account deactivated/reactivated). Visible to the user’s nursery managers, their org admins and platform admins; others see an empty list.
 * @summary View a user's login history
 */
export const getUserLoginAttempts = (
  id: string,
  params?: GetUserLoginAttemptsParams,
  signal?: AbortSignal,
) => {
  return axiosClient<GetUserLoginAttemptsResponseDto>({
    url: `/v1/users/${id}/login-attempts`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetUserLoginAttemptsQueryKey = (
  id: string,
  params?: GetUserLoginAttemptsParams,
) => {
  return [
    `/v1/users/${id}/login-attempts`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetUserLoginAttemptsQueryOptions = <
  TData = Awaited<ReturnType<typeof getUserLoginAttempts>>,
  TError = void,
>(
  id: string,
  params?: GetUserLoginAttemptsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserLoginAttempts>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetUserLoginAttemptsQueryKey(id, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getUserLoginAttempts>>
  > = ({ signal }) => getUserLoginAttempts(id, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: id !== null && id !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getUserLoginAttempts>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetUserLoginAttemptsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getUserLoginAttempts>>
>;
export type GetUserLoginAttemptsQueryError = void;

export function useGetUserLoginAttempts<
  TData = Awaited<ReturnType<typeof getUserLoginAttempts>>,
  TError = void,
>(
  id: string,
  params: undefined | GetUserLoginAttemptsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserLoginAttempts>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserLoginAttempts>>,
          TError,
          Awaited<ReturnType<typeof getUserLoginAttempts>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUserLoginAttempts<
  TData = Awaited<ReturnType<typeof getUserLoginAttempts>>,
  TError = void,
>(
  id: string,
  params?: GetUserLoginAttemptsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserLoginAttempts>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserLoginAttempts>>,
          TError,
          Awaited<ReturnType<typeof getUserLoginAttempts>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUserLoginAttempts<
  TData = Awaited<ReturnType<typeof getUserLoginAttempts>>,
  TError = void,
>(
  id: string,
  params?: GetUserLoginAttemptsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserLoginAttempts>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary View a user's login history
 */

export function useGetUserLoginAttempts<
  TData = Awaited<ReturnType<typeof getUserLoginAttempts>>,
  TError = void,
>(
  id: string,
  params?: GetUserLoginAttemptsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserLoginAttempts>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetUserLoginAttemptsQueryOptions(id, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Clears the user's own PIN and any lock, and stores a temporary PIN. On their next login the user must enter the temporary PIN and choose a new one. Platform admins may reset any user's PIN; managers and org admins only users they manage. Nobody may reset their own PIN here — use the self-service change-PIN flow.
 * @summary Reset a user's PIN to a temporary one
 */
export const managerSetUserPinCommandControllerSetPin = (
  id: string,
  managerSetUserPinDto: ManagerSetUserPinDto,
  signal?: AbortSignal,
) => {
  return axiosClient<void>({
    url: `/v1/users/${id}/pin`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: managerSetUserPinDto,
    signal,
  });
};

export const getManagerSetUserPinCommandControllerSetPinMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof managerSetUserPinCommandControllerSetPin>>,
    TError,
    { id: string; data: ManagerSetUserPinDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof managerSetUserPinCommandControllerSetPin>>,
  TError,
  { id: string; data: ManagerSetUserPinDto },
  TContext
> => {
  const mutationKey = ["managerSetUserPinCommandControllerSetPin"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof managerSetUserPinCommandControllerSetPin>>,
    { id: string; data: ManagerSetUserPinDto }
  > = (props) => {
    const { id, data } = props ?? {};

    return managerSetUserPinCommandControllerSetPin(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ManagerSetUserPinCommandControllerSetPinMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof managerSetUserPinCommandControllerSetPin>>
  >;
export type ManagerSetUserPinCommandControllerSetPinMutationBody =
  ManagerSetUserPinDto;
export type ManagerSetUserPinCommandControllerSetPinMutationError = void;

/**
 * @summary Reset a user's PIN to a temporary one
 */
export const useManagerSetUserPinCommandControllerSetPin = <
  TError = void,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof managerSetUserPinCommandControllerSetPin>>,
      TError,
      { id: string; data: ManagerSetUserPinDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof managerSetUserPinCommandControllerSetPin>>,
  TError,
  { id: string; data: ManagerSetUserPinDto },
  TContext
> => {
  return useMutation(
    getManagerSetUserPinCommandControllerSetPinMutationOptions(options),
    queryClient,
  );
};
/**
 * Migration helper: resets each selected user to the given temporary PIN so they go through first-time setup on their next login. All-or-nothing — if any user is not manageable by the caller, nothing is written. The caller cannot include themselves.
 * @summary Set the same temporary PIN for several users at once
 */
export const bulkSetTemporaryPinsCommandControllerBulkSetPins = (
  bulkSetTemporaryPinsDto: BulkSetTemporaryPinsDto,
  signal?: AbortSignal,
) => {
  return axiosClient<void>({
    url: `/v1/users/pins/bulk-set`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: bulkSetTemporaryPinsDto,
    signal,
  });
};

export const getBulkSetTemporaryPinsCommandControllerBulkSetPinsMutationOptions =
  <TError = void, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof bulkSetTemporaryPinsCommandControllerBulkSetPins>
      >,
      TError,
      { data: BulkSetTemporaryPinsDto },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof bulkSetTemporaryPinsCommandControllerBulkSetPins>
    >,
    TError,
    { data: BulkSetTemporaryPinsDto },
    TContext
  > => {
    const mutationKey = ["bulkSetTemporaryPinsCommandControllerBulkSetPins"];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof bulkSetTemporaryPinsCommandControllerBulkSetPins>
      >,
      { data: BulkSetTemporaryPinsDto }
    > = (props) => {
      const { data } = props ?? {};

      return bulkSetTemporaryPinsCommandControllerBulkSetPins(data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type BulkSetTemporaryPinsCommandControllerBulkSetPinsMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof bulkSetTemporaryPinsCommandControllerBulkSetPins>>
  >;
export type BulkSetTemporaryPinsCommandControllerBulkSetPinsMutationBody =
  BulkSetTemporaryPinsDto;
export type BulkSetTemporaryPinsCommandControllerBulkSetPinsMutationError =
  void;

/**
 * @summary Set the same temporary PIN for several users at once
 */
export const useBulkSetTemporaryPinsCommandControllerBulkSetPins = <
  TError = void,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof bulkSetTemporaryPinsCommandControllerBulkSetPins>
      >,
      TError,
      { data: BulkSetTemporaryPinsDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof bulkSetTemporaryPinsCommandControllerBulkSetPins>>,
  TError,
  { data: BulkSetTemporaryPinsDto },
  TContext
> => {
  return useMutation(
    getBulkSetTemporaryPinsCommandControllerBulkSetPinsMutationOptions(options),
    queryClient,
  );
};
/**
 * Platform admins only. Staff are added through POST /v1/nurseries/:nurseryId/staff.
 * @summary Create a user in an organisation
 */
export const createUserCommandControllerCreate = (
  createUserDto: CreateUserDto,
  signal?: AbortSignal,
) => {
  return axiosClient<UserResponseDto>({
    url: `/v1/users/create`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: createUserDto,
    signal,
  });
};

export const getCreateUserCommandControllerCreateMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createUserCommandControllerCreate>>,
    TError,
    { data: CreateUserDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createUserCommandControllerCreate>>,
  TError,
  { data: CreateUserDto },
  TContext
> => {
  const mutationKey = ["createUserCommandControllerCreate"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createUserCommandControllerCreate>>,
    { data: CreateUserDto }
  > = (props) => {
    const { data } = props ?? {};

    return createUserCommandControllerCreate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateUserCommandControllerCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof createUserCommandControllerCreate>>
>;
export type CreateUserCommandControllerCreateMutationBody = CreateUserDto;
export type CreateUserCommandControllerCreateMutationError = void;

/**
 * @summary Create a user in an organisation
 */
export const useCreateUserCommandControllerCreate = <
  TError = void,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createUserCommandControllerCreate>>,
      TError,
      { data: CreateUserDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createUserCommandControllerCreate>>,
  TError,
  { data: CreateUserDto },
  TContext
> => {
  return useMutation(
    getCreateUserCommandControllerCreateMutationOptions(options),
    queryClient,
  );
};
/**
 * Stops the user signing in and signs them out everywhere; their next request is rejected. Recorded in their login history. Platform admins may deactivate anyone; managers and org admins only users they manage. Only a platform admin may deactivate a platform admin. Nobody may deactivate themselves. Deactivating an inactive account does nothing.
 * @summary Deactivate a user's account
 */
export const deactivateUser = (id: string, signal?: AbortSignal) => {
  return axiosClient<void>({
    url: `/v1/users/${id}/deactivate`,
    method: "POST",
    signal,
  });
};

export const getDeactivateUserMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deactivateUser>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deactivateUser>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["deactivateUser"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deactivateUser>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return deactivateUser(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeactivateUserMutationResult = NonNullable<
  Awaited<ReturnType<typeof deactivateUser>>
>;

export type DeactivateUserMutationError = void;

/**
 * @summary Deactivate a user's account
 */
export const useDeactivateUser = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deactivateUser>>,
      TError,
      { id: string },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deactivateUser>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getDeactivateUserMutationOptions(options), queryClient);
};
/**
 * Lets a deactivated user sign in again. Recorded in their login history. Platform admins may reactivate anyone; managers and org admins only users they manage. Only a platform admin may reactivate a platform admin. Nobody may reactivate themselves. Activating an active account does nothing.
 * @summary Reactivate a user's account
 */
export const activateUser = (id: string, signal?: AbortSignal) => {
  return axiosClient<void>({
    url: `/v1/users/${id}/activate`,
    method: "POST",
    signal,
  });
};

export const getActivateUserMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof activateUser>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof activateUser>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["activateUser"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof activateUser>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return activateUser(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type ActivateUserMutationResult = NonNullable<
  Awaited<ReturnType<typeof activateUser>>
>;

export type ActivateUserMutationError = void;

/**
 * @summary Reactivate a user's account
 */
export const useActivateUser = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof activateUser>>,
      TError,
      { id: string },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof activateUser>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getActivateUserMutationOptions(options), queryClient);
};
/**
 * Sets a temporary password and revokes the user's refresh tokens, so other sessions end when their current token expires (within an hour). On their next login they must choose their own password. Recorded in their login history. Platform admins may reset anyone; managers and org admins only users they manage. Only a platform admin may reset a platform admin. Nobody may reset their own password here — use change-password.
 * @summary Reset a user's password to a temporary one
 */
export const resetUserPassword = (
  id: string,
  resetUserPasswordDto: ResetUserPasswordDto,
  signal?: AbortSignal,
) => {
  return axiosClient<void>({
    url: `/v1/users/${id}/reset-password`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: resetUserPasswordDto,
    signal,
  });
};

export const getResetUserPasswordMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof resetUserPassword>>,
    TError,
    { id: string; data: ResetUserPasswordDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof resetUserPassword>>,
  TError,
  { id: string; data: ResetUserPasswordDto },
  TContext
> => {
  const mutationKey = ["resetUserPassword"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof resetUserPassword>>,
    { id: string; data: ResetUserPasswordDto }
  > = (props) => {
    const { id, data } = props ?? {};

    return resetUserPassword(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ResetUserPasswordMutationResult = NonNullable<
  Awaited<ReturnType<typeof resetUserPassword>>
>;
export type ResetUserPasswordMutationBody = ResetUserPasswordDto;
export type ResetUserPasswordMutationError = void;

/**
 * @summary Reset a user's password to a temporary one
 */
export const useResetUserPassword = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof resetUserPassword>>,
      TError,
      { id: string; data: ResetUserPasswordDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof resetUserPassword>>,
  TError,
  { id: string; data: ResetUserPasswordDto },
  TContext
> => {
  return useMutation(getResetUserPasswordMutationOptions(options), queryClient);
};
